<style lang="stylus" scoped>
    .left-panel-more
        color var(--text-color-primary)
        .title
            height 40px
            padding 0 16px
            line-height 40px
            font-size 14px
            font-weight 700
        .children
            display flex
            align-items center
            height 56px
            margin 0 12px
            padding 4px
            margin-bottom 8px
            border-radius 6px
            cursor pointer
        .children:hover
            background-color var(--bg-color-left-panel-more)
            .children-icon
                background-color var(--bg-color-left-panel-more-hover)
        .children-icon
            display flex
            justify-content center
            align-items center
            width 48px
            height 48px
            border-radius 8px
            background-color var(--bg-color-left-panel-more)
            svg
                width 24px
                height 24px
                color var(--svg-color-primary)
        .children-text
            max-width 160px
            margin-left 8px
</style>

<template>
    <div class="left-panel-more">
        <div v-for="(item, index) in list" :key="index">
            <div class="title">{{ item.title }}</div>
            <div v-for="(child, childIndex) in item.children" :key="childIndex" class="children" @click="showDialogHandler(child)">
                <div class="children-icon">
                    <iconSymbol :name="child.icon"></iconSymbol>
                </div>
                <div class="children-text">{{ child.title }}</div>
            </div>
        </div>
    </div>
</template>

<script lang="ts">
    /**
     * @file 左侧侧边栏--更多工具
     * @author luokq
     */

    import { Component, Vue } from "vue-property-decorator";
    import InsertDropsMixins from "@/app/components/DropMenus/insertDropsMixins";

    @Component({})
    export default class More extends InsertDropsMixins {
        get list() {
            let data = [
                {
                    title: this.$t("Diagram"),
                    children: this.internal
                        ? [
                              {
                                  title: this.$t("Containers"),
                                  icon: "left-panel-more-container",
                                  target: "InsertContainer",
                                  toolType: "container",
                              },
                              {
                                  title: this.$t("Map"),
                                  icon: "left-panel-more-map",
                                  target: "InsertMap",
                                  toolType: "map",
                              },
                          ]
                        : [
                              {
                                  title: this.$t("Containers"),
                                  icon: "left-panel-more-container",
                                  target: "InsertContainer",
                                  toolType: "container",
                              },
                          ],
                },
                {
                    title: this.$t("Research"),
                    children: [
                        {
                            title: this.$t("Table"),
                            icon: "left-panel-more-table",
                            target: "InsertTable",
                            toolType: "table",
                        },
                        {
                            title: this.$t("MathEquations"),
                            icon: "left-panel-more-math",
                            target: "Math",
                            toolType: "math equation",
                        },
                    ],
                },
                {
                    title: this.$t("OtherTools"),
                    children: [
                        {
                            title: this.$t("Watermark"),
                            icon: "left-panel-more-watermark",
                            target: "InsertWaterMark",
                            toolType: "watermark",
                        },
                        {
                            title: this.$t("OCRText"),
                            icon: "left-panel-more-orc",
                            target: "OCRModal",
                            toolType: "ocr",
                        },
                        {
                            title: this.$t("QRCode"),
                            icon: "left-panel-more-qr",
                            target: "InsertQRCode",
                            toolType: "qrcode",
                        },
                    ],
                },
            ];

            if (window.EDCONFIG.IS_SDK) {
                data.forEach((item) => {
                    item.children = item.children.filter((child) => child.toolType !== "ocr" && child.toolType !== "container");
                });
                data = data.filter((item) => item.children.length);
            }

            return data;
        }

        showDialogHandler({ target, toolType }) {
            this.sensors.track("Moretoolsdetail", {
                Catalogues: "leftResource",
                more_tool_type: toolType,
            });
            if (target === "InsertContainer") {
                this.insertContainerHandler();
                return;
            } else if (target === "InsertMap") {
                this.showMapHandler();
                return;
            }

            this.showDialog(target);
        }
    }
</script>

<i18n>
{
    "zh": {
        "Diagram": "制图",
        "Containers": "容器",
        "Map": "地图",
        "Research": "研究",
        "Table": "表格",
        "MathEquations": "数学公式",
        "OtherTools": "其他工具",
        "Watermark": "水印工具",
        "OCRText": "OCR提取文本",
        "QRCode": "二维码生成"
    },
    "en": {
        "Diagram": "Diagram",
        "Containers": "Container",
        "Map": "Map",
        "Research": "Research",
        "Table": "Table",
        "MathEquations": "Math Equation",
        "OtherTools": "Other Tools",
        "Watermark": "Watermark",
        "OCRText": "OCR Image Text Extraction",
        "QRCode": "QR Code"
    },
    "fr": {
        "Diagram": "Diagramme",
        "Containers": "Récipient",
        "Map": "Carte",
        "Research": "Recherche",
        "Table": "Table",
        "MathEquations": "Équation mathématique",
        "OtherTools": "Autres outils",
        "Watermark": "Filigrane",
        "OCRText": "Extraction de texte d'image via OCR",
        "QRCode": "Code QR"
    },
    "de": {
        "Diagram": "Diagramm",
        "Containers": "Behälter",
        "Map": "Landkarte",
        "Research": "Forschung",
        "Table": "Tabelle",
        "MathEquations": "Mathematische Formel",
        "OtherTools": "Andere Werkzeuge",
        "Watermark": "Wasserzeichen",
        "OCRText": "OCR Bild-Text-Extraktion",
        "QRCode": "QR Kode"
    },
    "jp": {
        "Diagram": "ダイアグラム",
        "Containers": "容器",
        "Map": "マップ",
        "Research": "研究",
        "Table": "表",
        "MathEquations": "数式",
        "OtherTools": "その他のツール",
        "Watermark": "透かし",
        "OCRText": "OCR画像テキスト抽出",
        "QRCode": "QRコード"
    },
    "es": {
        "Diagram": "Diagrama",
        "Containers": "Contenedor",
        "Map": "Mapa",
        "Research": "Investigación",
        "Table": "Mesa",
        "MathEquations": "Ecuación matemática",
        "OtherTools": "Otras herramientas",
        "Watermark": "Marca de agua",
        "OCRText": "Extracción de texto de imágenes con OCR",
        "QRCode": "Código QR"
    },
    "pt": {
        "Diagram": "Diagrama",
        "Containers": "Contêiner",
        "Map": "Mapa",
        "Research": "Pesquisa",
        "Table": "Tabela",
        "MathEquations": "Equação Matemática",
        "OtherTools": "Outras ferramentas",
        "Watermark": "Marca de Água",
        "OCRText": "Extração de texto de imagem por OCR",
        "QRCode": "Código QR"
    },
    "it": {
        "Diagram": "Diagramma",
        "Containers": "Contenitore",
        "Map": "Mappa",
        "Research": "Ricerca",
        "Table": "Tabella",
        "MathEquations": "Equazione Matematica",
        "OtherTools": "Altri strumenti",
        "Watermark": "Filigrana",
        "OCRText": "Estrazione del testo da immagine OCR",
        "QRCode": "Codice QR"
    },
    "tw": {
        "Diagram": "圖表",
        "Containers": "容器",
        "Map": "地圖",
        "Research": "研究",
        "Table": "表格",
        "MathEquations": "數學公式",
        "OtherTools": "其他工具",
        "Watermark": "水印",
        "OCRText": "OCR 影像文字擷取",
        "QRCode": "二維碼"
    },
    "kr": {
        "Diagram": "다이어그램",
        "Containers": "컨테이너",
        "Map": "지도",
        "Research": "연구",
        "Table": "표",
        "MathEquations": "수학 공식",
        "OtherTools": "기타 도구",
        "Watermark": "워터마크 도구",
        "OCRText": "OCR 이미지 텍스트 추출",
        "QRCode": "QR코드"
    }
}
</i18n>
